import React from 'react'

import { Divider, ItemWrapper, Wrapper } from './BusinessContactBanner.styles'
import { Link, Text } from '@sketch/components'

import { ReactComponent as ArrowIcon } from '@sketch/icons/arrow-up-right-circle-semifilled-17'
import { ReactComponent as BookIcon } from '@sketch/icons/book-17'
import { SKETCH_WEBSITE } from '@sketch/env-config'

export const BusinessContactBanner = () => {
  return (
    <Wrapper>
      <Divider />
      <ItemWrapper>
        <ArrowIcon role="img" />
        <Text textStyle="copy.tertiary.standard.D">
          Visit{' '}
          <Link external href={`${SKETCH_WEBSITE}/pricing/`}>
            our pricing page
          </Link>{' '}
          to see what you’ll get with Standard and Professional — as well as our
          Enterprise and Private Cloud plans.
        </Text>
      </ItemWrapper>
      <ItemWrapper>
        <BookIcon role="img" />
        <Text textStyle="copy.tertiary.standard.D">
          Sketch is{' '}
          <Link external href={`${SKETCH_WEBSITE}/education/`}>
            free for students and educators
          </Link>
          .
        </Text>
      </ItemWrapper>
    </Wrapper>
  )
}
